import { useRef, useEffect } from 'react';
import { useThree, useFrame } from '@react-three/fiber';
// import * as THREE from 'three';

export function CameraControls() {
  const { camera } = useThree();
  const mouseRef = useRef([0, 0]);

  useEffect(() => {
    camera.near = 1;
    camera.far = 500;
    camera.updateProjectionMatrix();
  }, [camera]);

  useEffect(() => {
    const handleMouseMove = (event) => {
      mouseRef.current = [
        (event.clientX - window.innerWidth / 2) * 0.05,
        (event.clientY - window.innerHeight / 2) * 0.05
      ];
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  useFrame(() => {
    const [mouseX, mouseY] = mouseRef.current;
    camera.position.x += (mouseX - camera.position.x) * 0.01;
    camera.position.y += (-mouseY - camera.position.y) * 0.01;
  });

  return null;
}